import { BlocksIconMenuDots } from 'blocks-nextjs/blocks-web-components/components/icon/icons/menu-dots';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMenuDots = createComponent({ react: React, tagName: 'cat-icon-menu-dots', elementClass: BlocksIconMenuDots });
